import { render, staticRenderFns } from "./glassBlockEditDialog.vue?vue&type=template&id=555e4da2&"
import script from "./glassBlockEditDialog.vue?vue&type=script&lang=js&"
export * from "./glassBlockEditDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports